import React from 'react';
import BackupOptionSelect from './BackupOptionSelect';

type BackupSelections = {
    weekly_backups?: number | null;
    daily_backups?: number | null;
    monthly_backups?: number | null;
};

type BackupOptionsProps = {
    selections: BackupSelections;
    inclusions: BackupSelections;
    onChange: (selections: Partial<BackupSelections>) => void;
    costPerBackup: number;
    errors?: { [K in keyof BackupSelections]: string[] };
};

export default class BackupOptions extends React.Component<BackupOptionsProps> {
    render() {
        const { selections, inclusions, errors, onChange, costPerBackup } = this.props;

        return (
            <>
                <BackupOptionSelect
                    cost_per_backup={costPerBackup}
                    type="daily"
                    duration="day"
                    included={inclusions.daily_backups ?? 0}
                    value={selections.daily_backups ?? 0}
                    error={errors?.daily_backups ?? []}
                    onChange={(num) => onChange({ daily_backups: num })}
                ></BackupOptionSelect>
                <BackupOptionSelect
                    cost_per_backup={costPerBackup}
                    type="weekly"
                    duration="week"
                    included={inclusions.weekly_backups ?? 0}
                    value={selections.weekly_backups ?? 0}
                    error={errors?.weekly_backups ?? []}
                    onChange={(num) => onChange({ weekly_backups: num })}
                ></BackupOptionSelect>
                <BackupOptionSelect
                    cost_per_backup={costPerBackup}
                    type="monthly"
                    duration="month"
                    included={inclusions.monthly_backups ?? 0}
                    value={selections.monthly_backups ?? 0}
                    error={errors?.monthly_backups ?? []}
                    onChange={(num) => onChange({ monthly_backups: num })}
                ></BackupOptionSelect>
            </>
        );
    }
}
